<template>
  <section class="trusted-area rg-area breadcrumb-area text-center custom-background">
    <div class="trusted-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="trusted-content">
              <div class="trusted__title">
                <p v-if="preTitle" class="slider-one__text rg-black bold">{{preTitle}}</p>
                <h2 class="trusted__title-title rg-header-title">
                  <slot></slot>
                </h2>
                <!--h2 class="trusted__title-title">{{ title }} <span class="rg-black">{{titleStrong}}</span> </h2-->
              </div><!-- end trusted__title -->
            </div><!-- end trusted-content -->
          </div><!-- end col-md-12 -->
        </div><!-- end row -->
      </div><!-- container -->
    </div><!-- end trusted-fluid -->
  </section>
</template>

<script>
export default {
  name: "MPHeader",
  props: {
    preTitle: {
      type: String
    }
  },
}
</script>

<style scoped>
.custom-background {
  background-image: none;
  background-color: #28DE18;
  background-position-y: top;
}
</style>
